// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2h_xt","question":"styles_question__1QSF3","description":"styles_description__3lwsn"};